'use client';

import React, { useEffect } from 'react';

interface ToastProps {
  title: string;
  description: string | React.ReactNode;
  isVisible: boolean;
  onDismiss: () => void;
  className?: string;
  variant?: 'primary';
}

export const Toast = ({
  title,
  description,
  isVisible,
  onDismiss,
  className = '',
  variant,
}: ToastProps) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onDismiss();
      }, 3000); // Disappear after 3 seconds

      return () => clearTimeout(timer);
    }
  }, [isVisible, onDismiss]);

  const variantClasses = variant === 'primary' ? 'bg-primary text-white' : 'bg-gray-200';
  const titleClasses =
    variant === 'primary' ? 'py-2 text-2xl leading-8' : 'py-2 text-3xl leading-8';
  const bodyClasses =
    variant === 'primary'
      ? 'pt-2 text-base font-poppins leading-6'
      : 'pt-2 text-base font-poppins leading-6';

  return (
    <div
      className={`fixed top-6 right-6 w-100 min-h-44 max-h-96 overflow-y-auto rounded-3xl shadow-3xl cursor-pointer
        transition-all duration-300 ease-in-out transform z-50
        ${variantClasses}
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4 pointer-events-none'}
        ${className}`}
      onClick={onDismiss}
    >
      <div className="flex flex-col font-outfit p-8">
        <h1 className={titleClasses}>{title}</h1>
        <p className={bodyClasses}>{description}</p>
      </div>
    </div>
  );
};
